export default {
  computed: {
    barChartOptions() {
      if (!this.bigSmallFlow) return {}
      const options = {
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#838D9E'
            },
            margin: 20
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          show: false
        },
        grid: {
          top: 18,
          left: 0,
          right: 0,
          bottom: 30
        },
        series: [
          {
            name: '0',
            type: 'bar',
            barMaxWidth: 15,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: this.curTheme[this.theme].fontColor
                }
              }
            }
          }
        ]
      }

      // X Axis Labels
      options.xAxis.data = this.bigSmallFlow.map(item => {
        const valObject = {
          value: item.name,
          textStyle: {
            fontSize: 12,
            verticalAlign: 'top',
            lineHeight: 30
          }
        }
        return valObject
      })
      // Bar Values
      options.series[0].data = this.bigSmallFlow.map(item => {
        const valObject = {
          value: parseFloat(item.value).toFixed(1),
          itemStyle: {
            normal: {
              color: item.color
            }
          },
          label: {
            normal: {
              formatter() {
                return item.showValue
              },
              textStyle: {
                color: this.getBarFontColor(item.value)
              },
              rotate: 0,
              position: item.value > 0 ? 'top' : 'bottom'
            }
          }
        }
        return valObject
      })
      return options
    }
  },
  methods: {
    getBarFontColor(value) {
      if (this.isRedUp) {
        if (value > 0) {
          return this.curTheme[this.theme].red
        }
        if (value < 0) {
          return this.curTheme[this.theme].green
        }
      }
      if (value > 0) {
        return this.curTheme[this.theme].green
      }
      if (value < 0) {
        return this.curTheme[this.theme].red
      }
    }
  }
}
